import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from './sidebar/AppSidebar';
import { Header } from './header/Header';
import { AskAssistantDrawer } from '@/components/ai/AskAssistantDrawer';

export function AppLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <Header />
        <main className="flex-1 overflow-auto p-4 md:p-6">
          <Outlet />
        </main>
      </SidebarInset>
      {/* Mounted once so Ask ActiveID is reachable anywhere and the conversation persists. */}
      <AskAssistantDrawer />
    </SidebarProvider>
  );
}
